import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PrevArrow extends Component {
    static propTypes = {
        onClick: PropTypes.func,
    };

    render() {
        return (
            <button
                aria-label="Forrige bilde"
                className="blank lightbox-left button button--pill u-pa16"
                onClick={this.props.onClick}
                style={{ zIndex: 2 }}
                type="button"
            >
                <svg height="40" viewBox="0 0 10 20" width="20">
                    <path
                        d="M9 1l-8 9 8 9"
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            </button>
        );
    }
}
